import { css } from "../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      position: "relative",
      width: "100vw",
      left: "50%",
      marginLeft: "-50vw",
      paddingTop: "baseUnit.mobile4",
      textAlign: "center",
      overflow: "hidden",
      tablet: {
        textAlign: "left",
      },
      desktop: {
        paddingTop: "baseUnit.mobile6",
      },
    }),
  partnerNoteWrapper: () =>
    css({
      marginBottom: "baseUnit.mobile2",
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      gap: "baseUnit.mobile1",
      tablet: {
        justifyContent: "flex-start",
        textAlign: "left",
      },
    }),
  partnerNoteText: () =>
    css({
      textTransform: "uppercase",
      fontWeight: 600,
      color: "headlineGrey",
    }),
  titleWrapper: () =>
    css({
      marginInline: "auto",
      marginBottom: "baseUnit.mobile2",
      width: "fit-content",
      textAlign: "left",
      tablet: {
        marginTop: 0,
        marginX: 0,
        marginBottom: "baseUnit.mobile2",
        width: "auto",
        textAlign: "left",
      },
    }),
  titleText: () =>
    css({
      boxDecorationBreak: "clone",
      display: "inline",
      paddingBlock: 0,
      backgroundColor: "transparent",
      paddingInline: 0,
      lineHeight: "heading.H1.mobile",
      tablet: {
        lineHeight: "heading.H1.desktop",
      },
    }),
  description: () =>
    css({
      marginBottom: "baseUnit.mobile3",
      textAlign: "left",
      "& p": {
        marginBottom: 0,
      },
      "& b": {
        fontWeight: 700,
      },
    }),
  partnerLogo: () =>
    css({
      maxHeight: "18px",
    }),
  cta: (vinSearch: boolean) =>
    css({
      marginTop: "baseUnit.mobile1",
      marginX: 0,
      marginBottom: "baseUnit.mobile3",
      textAlign: vinSearch ? "left" : "center",
      tablet: {
        marginTop: 0,
        textAlign: "initial",
      },
    }),
  sampleReport: () =>
    css({
      marginTop: "baseUnit.mobile1",
      marginX: 0,
      marginBottom: "baseUnit.mobile3",
      textAlign: "left",
      color: "skyBlue",
      "& a, & button": {
        color: "skyBlue",
      },
      tablet: {
        marginTop: 0,
        textAlign: "initial",
      },
    }),
  vinSearchWrapper: (hasFooter?: boolean) =>
    css({
      marginTop: "baseUnit.mobile3",
      marginBottom: hasFooter ? "baseUnit.mobile1" : "baseUnit.mobile3",
      textAlign: "left",
      "& form": {
        marginLeft: 0,
        marginRight: "auto",
      },
    }),
  linkWrapper: () =>
    css({
      marginTop: "baseUnit.mobile1",
      marginX: 0,
      marginBottom: "baseUnit.mobile3",
      textAlign: "left",
      tablet: {
        marginTop: 0,
        textAlign: "initial",
      },
    }),
  additionalLinkWrapper: () =>
    css({
      marginBottom: "baseUnit.mobile3",
      "& a": {
        position: "relative",
        tablet: {
          marginLeft: "baseUnit.mobile1",
        },
        _before: {
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          left: "-8px",
          content: "'›'",
        },
      },
    }),
  trustIcons: () =>
    css({
      height: "88px",
      backgroundColor: "white",
      display: "flex",
      columnGap: "baseUnit.mobile4",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      color: "headlineGrey",
      flexWrap: "wrap",
      marginBottom: "baseUnit.mobile2",
      "& img": {
        width: "80px",
        height: "40px",
      },
      "& div:first-of-type": {
        width: "100%",
        textAlign: "center",
        marginTop: "baseUnit.mobile2",
        marginBottom: "baseUnit.mobile1",
      },
      desktop: {
        margin: 0,
        "& img": {
          marginTop: "baseUnit.mobile1",
        },
        "& div:first-of-type": {
          width: "auto",
        },
      },
    }),
};
